import { API_ROUTES, IOrderConfirmedRequestParams } from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import {
  getHTTPRoutePrefix,
  getLobOnServerSide,
  getPathPartnerOnServerSide,
} from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getOrderConfirmedDetails = async (
  data: IOrderConfirmedRequestParams
): Promise<any> => {
  const { partner, bookingId, headers, cmp, query, dvid, itineraryId } = data;
  try {
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      tmBookingId: bookingId,
      itineraryId: itineraryId || "",
      ...query,
    };

    const urlParams = setURLQueryParams(params);
    const httpRoutePrefix = getHTTPRoutePrefix(partner);
    const pathPartner = getPathPartnerOnServerSide(partner);

    const response = await API_HTTP.get(
      `${httpRoutePrefix}/${pathPartner}/${API_ROUTES.ORDER_CONFIRMED}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: {
          ...headers,
          cmp:
            (typeof window !== "undefined" && sessionStorage.getItem("cmp")) ||
            cmp ||
            "fallback_thanksyou",
          dvid,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};
